import { ResultsSummary } from "../../types/funnelback/Response";
import { ItemTypeValues } from "./PaginationItem";
import getPageNumber from "./getPageNumber";

type ControlProps = {
    itemType?: ItemTypeValues;
    stepLabel?: string;
    url?: string;
};

type ItemProps = {
    isCurrent?: boolean;
    itemType?: ItemTypeValues;
    pageNumber: number;
    stepLabel?: string;
    url?: string;
};

export type PaginationNavProps = {
    controls: {
        next: ControlProps | null;
        previous: ControlProps | null;
    } | null;
    items: ItemProps[];
    limit: number;
};

const getfirstPage = (
    currentPage: number,
    totalPages: number,
    displayedPages: number
): number => {
    const middlePage = Math.ceil(displayedPages / 2);
    let firstPage: number;

    if (totalPages <= displayedPages) {
        // If the total number of pages is less than or equal to the display pages count,
        // the first page will always be 1.
        firstPage = 1;
    } else if (currentPage <= middlePage) {
        // If the current page is less than or equal to the middle page,
        // the first page will also be 1.
        firstPage = 1;
    } else if (currentPage >= totalPages - middlePage + 1) {
        // If the current page is greater than or equal to the (totalPages - middlePage + 1),
        // then the first page will be (totalPages - displayedPages + 1).
        firstPage = totalPages - displayedPages + 1;
    } else {
        // Otherwise, the first page will be the current page minus the middle page.
        firstPage = currentPage - middlePage + 1;
    }
    return firstPage;
};

const formatPaginationData = (
    resultsSummary: ResultsSummary,
    maxPages: number
): PaginationNavProps => {
    if (maxPages < 1) {
        return {
            controls: {
                next: null,
                previous: null,
            },
            items: [],
            limit: 10,
        };
    }
    const { currStart, nextStart, numRanks, prevStart, totalMatching } =
        resultsSummary;
    const limit = numRanks && numRanks > 0 ? numRanks : 1;
    const totalPages = totalMatching ? Math.ceil(totalMatching / limit) : 0;
    const displayedPages = totalPages > maxPages ? maxPages : totalPages;
    const currentPage = getPageNumber(currStart, limit);
    const firstPage = getfirstPage(currentPage, totalPages, displayedPages);

    const controls: {
        next: ControlProps | null;
        previous: ControlProps | null;
    } = {
        next: nextStart ? {} : null,
        previous: prevStart ? {} : null,
    };

    const items = Array.from({ length: displayedPages }, (data, pageIndex) => {
        const pageNumber = pageIndex + firstPage;
        const item: ItemProps = {
            pageNumber: pageNumber,
            isCurrent: pageNumber == currentPage,
        };
        return item;
    });

    const pagination = {
        controls,
        items,
        limit,
    };

    return pagination;
};

export default formatPaginationData;
